<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageATrustRegMobile.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageATrustRegMobile.card.general')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageATrustRegMobile.enabled')"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input :label="$t('admin.interfaces.pageATrustRegMobile.apiUsername')"
                    :disabled="!hasRole('ROLE_SYSADMIN')"
                    v-model="config.apiUsername"
                    cols="12 6@hd start-1"
                    name="apiUsername" />
          <hm-input :label="$t('admin.interfaces.pageATrustRegMobile.apiPassword')"
                    :disabled="!hasRole('ROLE_SYSADMIN')"
                    v-model="config.apiPassword"
                    type="password"
                    cols="12 6@hd start-1"
                    name="apiPassword" />
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageATrustRegMobile.card.certificate')">
          <hm-input :label="$t('admin.interfaces.pageATrustRegMobile.zdaId')"
                    :disabled="true"
                    v-model="config.zdaId"
                    cols="12 6@hd start-1"
                    name="zdaId" />
          <hm-input :label="$t('admin.interfaces.pageATrustRegMobile.activeCertSerialNumber')"
                    :disabled="true"
                    v-model="config.activeCertSerialNumber"
                    cols="12 6@hd start-1"
                    name="activeCertSerialNumber" />
        </hm-card-inner>
      </card>
      <template v-if="!isEmpty(config.certificateList)">
        <card v-for="(certificate, idx) in config.certificateList"
              :key="certificate.serialNumberHex"
              :title="`${idx+1}. ${$t('admin.interfaces.pageATrustRegMobile.card.certificate')}`"
              cols="12 6@desktop">
          <hm-card-inner>
            <hm-input :label="$t('admin.interfaces.pageATrustRegMobile.activeCertSerialNumber')"
                      :disabled="true"
                      v-model="certificate.serialNumberHex"
                      cols="12 6@hd start-1"
                      name="activeCertSerialNumber" />
            <hm-input :label="$t('admin.interfaces.pageATrustRegMobile.algorithm')"
                      :disabled="true"
                      v-model="certificate.algorithm"
                      cols="12 6@hd start-1"
                      name="activeCertSerialNumber" />
          </hm-card-inner>
        </card>
      </template>
    </template>
    <hm-floating-buttons>
      <hm-floating-button :throttle="3500"
                          :label="$t('admin.interfaces.pageATrustRegMobile.actions.reloadData')"
                          icon="download"
                          color="orange"
                          @click="refreshData()" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';

export default {
  name: 'PageATrustRegMobile',
  components: { HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        this.axios.put(this.serviceUrls.interfaces.aTrustRegMobile.get(this, this.config.id), this.config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.aTrustRegMobile.get(this, null))
        .then((response) => {
          if (isNil(this.config)) {
            this.config = response.data.data;
          }
        });
    },
    refreshData() {
      this.axios.post(this.serviceUrls.interfaces.aTrustRegMobile.refreshData(this, null))
        .then((response) => {
          this.config = response.data.data;
          this.showSuccessMessage();
        })
        .catch(() => {
          this.showErrorMessage();
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageATrustRegMobile.vue